export default "__VITE_ASSET__NQvTXIbg__"